
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { AuthProvider } from './contexts/AuthContext';
import CookieConsent from './components/feature/CookieConsent';
import { CacheIndicator } from './components/feature/CacheIndicator';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <AppRoutes />
        <CookieConsent />
        <CacheIndicator show={import.meta.env.DEV} />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
